import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../app/store"; // Adjust import based on location
import logo from "../assets/logo.png";
import ThemeSwitch from "../component/ThemeSwitch";
import {
  forgotPassword,
  resetForgotPasswordState,
} from "../features/auth/forgotPasswordSlice";

const Forgot: React.FC = () => {
  const [email, setEmail] = useState<string>("");

  const dispatch = useDispatch<AppDispatch>(); // Type dispatch as AppDispatch

  const { loading, error, successMessage } = useSelector(
    (state: RootState) => state.forgotPassword
  ); // Extract loading, error, and successMessage from Redux store

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(resetForgotPasswordState());
    dispatch(forgotPassword(email)); // Dispatch the forgotPassword action
    setEmail("");
  };

  return (
    <div className="transition-all duration-300 ease-soft-spring h-screen w-screen bg-[#F0F0F0] overflow-hidden dark:bg-gradient-to-r dark:from-[#07131C] dark:to-[#0C2538] md:pt-10 pt-0">
      {/* Theme Toggle */}
      <div className="auth_container">
        <div className="flex justify-end lg:-mr-10">
          <ThemeSwitch />
        </div>

        <div className="max-w-[45.5rem] w-full mt-10">
          <img alt="Your Company" src={logo} className="w-auto h-20" />
          <h2 className="mt-10 font-bold auth_head dark:text-white font-ProximaLight">
            <span className="text-[#265376]"> Change </span> <br /> Password
          </h2>
          <p className="pt-4 text-black dark:text-white">
            {/* A verification link will be sent on the email address. */}
            If an account exists, a reset link has been sent. Please check your inbox and spam folder
          </p>
          <div className="mt-5 max-w-[27.25rem]">
            <form
              onSubmit={handleSubmit}
              className="space-y-2"
              autoComplete="off"
            >
              <div className="relative dark:bg-[#031523] bg-[#e4e4e4] rounded-xl backdrop-blur-[20px]">
                <input
                  aria-autocomplete="none"
                  id="email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  className="auth_input block font-ProximaLight px-2.5 py-4 w-full text-sm text-black bg-transparent rounded-lg focus:outline-none appearance-none dark:text-white peer"
                  placeholder=" "
                />
                <label
                  htmlFor="email"
                  className="absolute text-sm text-[#5E829F] dark:text-[#5E829F] duration-300 transform -translate-y-4 scale-75 top-3 z-10 origin-[0] px-2 peer-focus:px-2  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-3 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                >
                  Email Address
                </label>
              </div>
              {/* Submit Button */}
              <div>
                <button
                  type="submit"
                  className="mt-5 flex w-full justify-center rounded-2xl bg-[#265376] px-3 py-4 text-white hover:bg-[#1F374A] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#9ca3af87]"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Submit"}
                </button>
              </div>
              {/* Display Error or Success Message */}
              {error && <p className="text-red-500">{error}</p>}{" "}
              {/* Display error message */}
              {successMessage && (
                <p className="text-green-500">{successMessage}</p>
              )}{" "}
              {/* Display success message */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forgot;
